// extracted by mini-css-extract-plugin
export default {"getCourseButton":"style_getCourseButton__ihzip","ghostImage":"style_ghostImage__TMFim"};